// @flow

import type { State } from "@store/reducers";
import type { EmailControlSettings } from "@modules/service/reducer/email-controls/types";

export const getEmailControlSettings = (state: State): ?EmailControlSettings =>
  state.service.emailControls.settings;

export const getAddEmailDomainModalVisible = (state: State): boolean =>
  state.service.emailControls.modals.addNewEmailDomain.visible;
